export default "__VITE_ASSET__c95848cb__"